import * as ss from 'superstruct';
export var EWaitlistStatus;
(function (EWaitlistStatus) {
    EWaitlistStatus["PENDING"] = "PENDING";
    EWaitlistStatus["APPROVED"] = "APPROVED";
    EWaitlistStatus["REJECTED"] = "REJECTED";
})(EWaitlistStatus || (EWaitlistStatus = {}));
export const CreateWaitlistEntrySchema = ss.type({
    email: ss.string(),
    firstname: ss.optional(ss.string()),
    lastname: ss.optional(ss.string()),
    country: ss.optional(ss.string()),
    source: ss.optional(ss.string()),
});
export const RejectWaitlistEntrySchema = ss.type({
    reason: ss.optional(ss.string()),
});
